const API_BASE_URL = process.env.REACT_APP_API_URL;

console.log(API_BASE_URL)
export const AppSettings = {
    baseLocation : API_BASE_URL,
    apiBase : `${API_BASE_URL}api/`
}